import { EColors } from 'common/styles'
import styled, { keyframes } from 'styled-components'

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`
export const AnimatedImage = styled.img<{ $delay?: number }>`
  opacity: 0;
  animation: ${fadeInUp} 0.5s ease-out forwards;
  animation-delay: ${({ $delay }) => $delay || 0}s;
  width: 100%;
  object-fit: cover;
`
export const ContantContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 72px;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  @media screen and (max-width: 1199px) {
    padding: 0 16px;
  }
`

export const Container = styled.section`
  position: relative;
  overflow: hidden;
  width: 100%;
  background-color: ${EColors.bg_light};
`

export const TitleWrapper = styled.div`
  opacity: 0;
  transform: translateY(-100%);
  animation: appearence 0.4s ease-out 0.2s forwards;

  @keyframes appearence {
    from {
      opacity: 0;
      transform: translateY(-100%);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const Title = styled.h2`
  font-size: 28px;
  margin-top: 60px;
  margin-bottom: 40px;
  font-weight: 500;
  color: ${EColors.neutral_800};
  font-family: 'playfair Display';
  @media (min-width: 768px) {
    font-size: 38px;
    margin-top: 45px;
  }
  @media (min-width: 1000px) {
    font-size: 48px;
    margin-top: 25px;
    margin-left: 40px;
  }
  @media (min-width: 1200px) {
    font-size: 68px;
    margin-top: 90px;
    margin-left: 60px;
  }
`

export const MobileImagesWrap = styled.div<{ $count?: number }>`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  img {
    width: 100%;
    object-fit: cover;
  }

  img:nth-child(1),
  img:nth-child(2) {
    height: 260px;
    width: calc(50% - 6px);
  }

  ${({ $count }) =>
    $count === 3 &&
    `
    img:nth-child(3) {
      height: 190px;
    }
  `}

  @media (min-width: 768px) {
    display: none;
  }
`

export const LinksList = styled.div`
  width: 100%;
  margin-top: 40px;
  margin-bottom: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  height: 50px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  a {
    text-decoration: none;
    color: ${EColors.primary_500};
    display: flex;
    justify-content: center;
    height: 100%;
    align-items: center;
    max-width: 200px;
    position: relative;

    &:last-child {
      height: 40px;
      padding: 0 14px;
      width: fit-content;
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 1px solid ${EColors.primary_500};
        border-radius: 80% / 80%;
        transform: rotate(-2.7deg);
        pointer-events: none;
      }
    }
  }

  @media (min-width: 768px) {
    width: 420px;
    margin-top: 5px;

    a {
      font-size: 16px;
    }
  }
  @media (min-width: 1000px) {
    margin-bottom: 4px;
    margin-top: 15px;
  }
  @media (min-width: 1200px) {
    a {
      &:last-child {
        height: 50px;
        width: 240px;
      }
    }
  }
`

export const MobileTextDescription = styled.p`
  font-size: 14px;
  line-height: 1.47;
  color: ${EColors.neutral_800};
  white-space: pre-wrap;
  font-family: 'Montserrat', sans-serif;
  @media (min-width: 768px) {
    display: none;
  }
`
export const DesktopWrap = styled.div`
  display: none;
  max-width: 1440px;
  margin: 0 auto;
  @media (min-width: 768px) {
    display: flex;
    gap: 12px;
  }
  @media (min-width: 1200px) {
    gap: 24px;
  }
`
export const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  img {
    width: 100%;
  }
  @media (min-width: 1000px) {
    &:nth-child(1) {
      img {
        max-height: 385px;
      }
    }
    &:nth-child(2) {
      img {
        max-height: 680px;
      }
    }
  }
  @media (min-width: 1200px) {
    gap: 24px;
  }
  p {
    font-size: 18px;
    line-height: 26px;
    white-space: pre-wrap;
    font-family: 'Montserrat', sans-serif;
    color: ${EColors.neutral_800};
  }
`
const slideDownFade = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-100%) ;
  }
  100% {
    opacity: 1;
    transform: translateY(0) ;
  }
`
export const ImageBadge = styled.svg`
  position: absolute;
  max-width: 50px;
  max-height: 50px;
  top: 10px;
  z-index: 1;
  right: 20px;
  fill: rgba(34, 34, 34, 0.12);

  transition: all 0.4s linear;
  cursor: pointer;
  animation: ${slideDownFade} 0.6s ease-out 0.3s both;
  use {
    width: 97px;
    height: 98px;
  }
  &:hover {
    fill: ${EColors.primary_500};
  }
  @media screen and (min-width: 1000px) {
    max-width: 97px;
    max-height: 98px;
    top: 1%;
  }
  @media screen and (min-width: 1200px) {
    top: 6%;
  }
`
